import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import {
  mapStatusToStatusStyle,
  mapStatusToCardStyle,
  showViewDetails,
} from '../../../helpers/policyQuoteCard';
import format from '../../../helpers/format';
import policiesQuotesActions from '../../../actions/policiesQuotes.actions';
import PoliciesQuotesDispatch from '../../../contexts/policiesQuotes.dispatch';

import style from './PoliciesQuotesPanelCard.module.css';
import SingleLineData from './SingleLineData';

const PoliciesQuotesPanelCard = React.memo(({ item, viewingDetails }) => {
  const policiesQuotesDispatch = useContext(PoliciesQuotesDispatch);

  const handleViewDetailsClick = event => {
    event.preventDefault();

    policiesQuotesDispatch({
      type: policiesQuotesActions.POLICIES_QUOTES_VIEW_DETAILS_REQUEST,
      id: item.Data.PolicyQuoteId,
      policy: item.Data.IsPolicy,
    });
  };

  const handleCloseDetailsClick = event => {
    event.preventDefault();

    policiesQuotesDispatch({
      type: policiesQuotesActions.POLICIES_QUOTES_VIEW_DETAILS_REQUEST,
      id: null,
    });
  };

  return item.Available ? (
    <div
      className={`${style.main} ${viewingDetails && style.viewingDetails}`}
      style={mapStatusToCardStyle(item.Data.Status)}
    >
      <div className={style.header}>
        <div>
          <span className={style.title}>
            {item.Data.IsPolicy ? 'Policy' : 'Quote'}
          </span>
          <span
            style={mapStatusToStatusStyle(item.Data.Status)}
            className={style.status}
          >
            {item.Data.Status}
          </span>
        </div>
        {showViewDetails(item.Data) &&
          (viewingDetails ? (
            <button
              className={style.closeBtn}
              type="button"
              onClick={handleCloseDetailsClick}
            >
              Close Details
            </button>
          ) : (
            <button
              className={style.viewBtn}
              type="button"
              onClick={event => {
                window.scroll(0, 0);
                handleViewDetailsClick(event);
              }}
            >
              View Details
            </button>
          ))}
      </div>
      <div className={style.policyId}>
        {item.Data.IsPolicy ? 'Policy ID' : 'Quote'} #{item.Data.Id}
      </div>
      <div className={style.lob}>{item.Data.Lob}</div>
      <div className={style.carrierInfo}>
        <span className={style.carrier}>{item.Data.Carrier}</span>
        <span className={style.premium}>
          {format.formatMoney(item.Data.Premium)}
        </span>
      </div>
      {item.Data.IsPolicy && (
        <SingleLineData
          label="Policy Number"
          value={item.Data.Number}
          type="default"
          contentStyle={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        />
      )}
      <SingleLineData
        label="Proposed Effective Date"
        value={format.formatDate(item.Data.EffectiveDate)}
        type="default"
        contentStyle={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      />
    </div>
  ) : (
    <div className={style.main} style={mapStatusToCardStyle(item.Data.Status)}>
      Data unavailable
    </div>
  );
});

PoliciesQuotesPanelCard.propTypes = {
  item: PropTypes.shape({}).isRequired,
  viewingDetails: PropTypes.bool.isRequired,
};

export default PoliciesQuotesPanelCard;
